import React, { useState, useEffect, useRef } from "react";

import ProgressCard from "./ProgressCard/ProgressCard";
import { BsChevronCompactDown, BsChevronCompactUp } from "react-icons/bs";

import "./VerticalProgressBar.scss";
type ContentType = {
  id?: string;
  title?: string;
  description?: string;
  link?: string;
  is_primary?: boolean;
  position?: number;
  master_content?: string;
  content_type?: string;
  thumbnail?: null | string;
  is_free?: boolean;
  is_complete?: boolean;
  current?: boolean;
};

let contents_prototype = [
  { is_complete: true, current: false, id: "870d4413-5355-49d5-96d1-f241a647186a", title: "Video on introduction to Caesar", description: "This is video about Caesar", link: "https://www.youtube.com/watch?v=J74B2jzr8iA", is_primary: true, position: 5, master_content: "d2e205ad-26c7-4466-8e21-a8ce0228a559", content_type: "video", thumbnail: "http://zununadmin.dipanbhusal.com.np/media/images/Introduction_to_Caesar_Cypher.png", is_free: false },
  { is_complete: true, current: false, id: "4e4f1960-3344-437e-8f4b-dc582ce5c12c", title: "Image on introduction to Caesar", description: "This is image about Caesar", link: "https://www.youtube.com/watch?v=J74B2jzr8iA", is_primary: true, position: 5, master_content: "d2e205ad-26c7-4466-8e21-a8ce0228a559", content_type: "image", thumbnail: null },
  { is_complete: true, current: false, id: "e254283b-458a-4f21-bd04-4ba6aa0cf31b", title: "Sunt eos et sit qui", description: "Excepteur sit aut l", link: "Quos nisi corporis m", is_primary: false, position: 7, master_content: "d2e205ad-26c7-4466-8e21-a8ce0228a559", content_type: "audio", thumbnail: null },
  { is_complete: true, current: false, id: "1794aab6-febf-45ee-bc67-91a4698d414b", title: "Audio on introduction to Caesar", description: "This is audio about Caesar", link: "https://www.youtube.com/watch?v=J74B2jzr8iA", is_primary: false, position: 8, master_content: "d2e205ad-26c7-4466-8e21-a8ce0228a559", content_type: "audio", thumbnail: null },
  { is_complete: true, current: false, id: "e2bc178f-78f8-4e29-baa2-0e8e9eb8074b", title: "Culpa natus est asp", description: "Vel nemo temporibus", link: "Modi quidem est volu", is_primary: false, position: 13, master_content: "d2e205ad-26c7-4466-8e21-a8ce0228a559", content_type: "audio", thumbnail: null },
  { is_complete: true, current: false, id: "4a39b3c6-e30b-491d-b646-363f059d3dd3", title: "At repudiandae sed d", description: "Odit a eos ad cupid", link: "Id illo praesentium", is_primary: false, position: 40, master_content: "d2e205ad-26c7-4466-8e21-a8ce0228a559", content_type: "audio", thumbnail: null },
  { is_complete: true, current: false, id: "b0b680dc-53db-4bcd-a39c-1a5b14beab02", title: "Assumenda aute paria", description: "Autem quos doloremqu", link: "Molestias similique", is_primary: false, position: 49, master_content: "d2e205ad-26c7-4466-8e21-a8ce0228a559", content_type: "video", thumbnail: null, is_free: false },
  { is_complete: false, current: true, id: "feae6c0b-3e68-4c07-b347-0e6f5d124483", title: "Consequatur Dolorem", description: "Soluta totam anim ma", link: "Laboriosam aspernat", is_primary: false, position: 68, master_content: "d2e205ad-26c7-4466-8e21-a8ce0228a559", content_type: "audio", thumbnail: null },
  { is_complete: false, current: false, id: "0413ccc9-7ef8-414a-bc4c-2c2dd67786f8", title: "Architecto voluptate", description: "Et dolore necessitat", link: "Deserunt ipsa minim", is_primary: false, position: 98, master_content: "d2e205ad-26c7-4466-8e21-a8ce0228a559", content_type: "audio", thumbnail: null },
];
export default function VerticalProgressBar() {
  const [contents, setContents] = useState<ContentType[]>(contents_prototype);

  const [isViewAll, setIsViewAll] = useState<boolean>(false);
  let progressContainerRef = useRef<HTMLDivElement | null>(null);

  function renderProgressCard() {
    return contents.map((content, index) => {
      return <ProgressCard content={content} key={index} />;
    });
  }

  const handleViewAllClick = () => {
    if (!isViewAll && progressContainerRef.current) {
      progressContainerRef.current.style.height = "100%";
      setIsViewAll(true);
    } else {
      progressContainerRef.current.style.height = "280px";
      setIsViewAll(false);
    }
  };

  return (
    <div className="vertical_progress_container">
      <div className="wrapper" ref={progressContainerRef}>
        <ul className="StepProgress">{renderProgressCard()}</ul>
      </div>
      <button className="button button_secondary" onClick={handleViewAllClick}>
        {isViewAll ? (
          <>
            View Less
            <span>
              <BsChevronCompactUp />
            </span>
          </>
        ) : (
          <>
            View All
            <span>
              <BsChevronCompactDown />
            </span>
          </>
        )}
      </button>
    </div>
  );
}
